/**
 * Size Guide Modal PDP - Custom Web Component
 * Modal for product pages with metaobject-driven size chart and measurement instructions
 */

class SizeGuideModalPDP extends HTMLElement {
  constructor() {
    super();
    this.dialog = null;
    this.tabs = [];
    this.tabContents = [];
    this.metricToggle = null;
    this.inchBody = null;
    this.metricBody = null;
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.tabContents = Array.from(this.querySelectorAll('[data-tab-content]'));
    this.metricToggle = this.querySelector('[data-metric-toggle]');
    this.inchBody = this.querySelector('[data-unit="inch"]');
    this.metricBody = this.querySelector('[data-unit="metric"]');

    if (!this.dialog) {
      console.error('Size Guide Modal PDP: Missing dialog element');
      return;
    }

    this.setupEventListeners();
    this.bindTriggers();
    this.initializeTabs();
  }

  bindTriggers() {
    document.querySelectorAll('[data-size-guide-trigger]').forEach(trigger => {
      trigger.addEventListener('click', () => this.open());
    });
  }

  setupEventListeners() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchTab(tab.dataset.tab);
      });
    });

    const closeButton = this.querySelector('[data-close-button]');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.close());
    }

    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.close();
      }
    });

    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
      }
    });

    if (this.metricToggle) {
      this.metricToggle.addEventListener('change', () => this.toggleUnit());
    }
  }

  initializeTabs() {
    if (this.tabs.length > 0) {
      this.switchTab(this.tabs[0].dataset.tab);
    }
  }

  switchTab(tabName) {
    this.tabs.forEach(tab => {
      tab.classList.toggle('size-guide-modal__tab--active', tab.dataset.tab === tabName);
    });

    this.tabContents.forEach(content => {
      content.classList.toggle('size-guide-modal__tab-content--active', content.dataset.tabContent === tabName);
    });
  }

  toggleUnit() {
    const useMetric = this.metricToggle && this.metricToggle.checked;

    if (this.inchBody) {
      this.inchBody.style.display = useMetric ? 'none' : '';
    }
    if (this.metricBody) {
      this.metricBody.style.display = useMetric ? '' : 'none';
    }
  }

  open() {
    if (this.dialog) {
      this.dialog.showModal();
      const firstTab = this.tabs[0];
      if (firstTab) {
        firstTab.focus();
      }
    }
  }

  close() {
    if (this.dialog) {
      this.dialog.close();
    }
  }
}

customElements.define('size-guide-modal', SizeGuideModalPDP);
